module.exports = __webpack_public_path__ + "media/WrongAnswer.f69bc8c8.mp3";